var _defs, _g, _path, _path2, _rect, _rect2, _rect3, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 146.09 112.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.55,27.7l-.1,38.92-18.36-25.47,18.33-14.27c.08.26.13.53.13.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.83,25.49l-28.87,22.47c-.64.51-1.47.5-2.1,0L2.84,25.33l59.99.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.14,41.45L.02,67.12c0-.1-.02-.2-.02-.3L.1,27.54c0-.29.05-.56.14-.82l18.9,14.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.07,69.1c-.16.06-.33.08-.51.08l-61.74-.16,19.35-25.99,9.34,7.28c.73.57,1.56.86,2.4.86.83,0,1.67-.29,2.41-.85l9.75-7.6,19.01,26.37Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.29,112.99c-19.58,0-37.84-10.17-48.13-26.92-.9-1.46-.37-3.38,1.14-4.2l3.53-1.91c1.4-.76,3.13-.28,3.97,1.07,9.16,14.74,25.85,23.23,43.32,21.8,18.55-1.53,34.41-14.06,40.28-31.54.5-1.5,2.08-2.36,3.61-1.95l3.88,1.05c1.66.45,2.61,2.2,2.08,3.83-7.07,21.37-26.39,36.72-49.02,38.58-1.55.13-3.11.19-4.65.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.82,52.42c-1.75.14-3.28-1.11-3.54-2.85-3.59-23.97-25.29-41.44-49.79-39.41-7.62.63-14.91,3.1-21.29,7.19-1.47.94-3.41.61-4.45-.79l-2.03-2.74c-1.13-1.52-.76-3.69.82-4.72C53.36,4.02,62.32.96,71.67.19c29.9-2.45,56.33,18.93,60.55,48.22.27,1.87-1.12,3.57-3.01,3.73l-3.39.28Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63.79,
    y: 31.78,
    width: 37.32,
    height: 4.93,
    rx: 2.46,
    ry: 2.46
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.04,
    y: 43.05,
    width: 37.32,
    height: 4.93,
    rx: 2.46,
    ry: 2.46
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.38,
    y: 55.73,
    width: 19.01,
    height: 4.93,
    rx: 2.46,
    ry: 2.46
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.1,62.88l-17.1-10.54c-1.95-1.2-2.56-3.76-1.36-5.71l.89-1.44c1.2-1.95,3.76-2.56,5.71-1.36l9.99,6.15c1.71,1.05,3.93.73,5.27-.77l8.09-9.04c1.53-1.71,4.15-1.85,5.86-.32l1.26,1.13c1.71,1.53,1.85,4.15.32,5.86l-13.67,15.27c-1.34,1.5-3.56,1.82-5.27.77Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.27,98.32c-1.77-.79-2.58-2.83-1.84-4.62,2.61-6.23,6.84-16.59,6.86-16.63l.47-1.03c.68-1.49,2.3-2.32,3.91-2.01l16.87,3.28c1.93.38,3.19,2.24,2.81,4.17l-.55,2.84c-.38,1.93-2.24,3.19-4.17,2.81l-9.1-1.77c-1.63-.32-3.27.54-3.94,2.06-1.55,3.52-3.17,7.32-4.25,10.02-.75,1.87-2.9,2.74-4.74,1.92l-2.34-1.04Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoMessage);
export default __webpack_public_path__ + "static/media/AutoMessage.ae8f96827f1d4fda602e69983dfd5481.svg";
export { ForwardRef as ReactComponent };